import {STORAGE_KEY} from './local-storage'

const localStoragePlugin = store => {
  store.subscribe((mutation, state) => {
    var _ = require('lodash')
    const mutationsToIgnore=[
      "SET_LOADING",
      "SET_DATA_TO_SYNCEDDATA_VUEX",
    ]
    if (_.indexOf(mutationsToIgnore, mutation.type)>=0)
      return

    const syncedData = state.stateLocalStorage.syncedData
  //   // debugger
  //   console.log("localStoragePlugin")
  //   console.log(mutation)
  //   console.log(state.stateLocalStorage.syncedData);
    // console.log(localStorage.getItem("abft_intranet"))
    localStorage.setItem(STORAGE_KEY, JSON.stringify(syncedData))
    if (mutation.type === 'CLEAR_ALL_DATA') {
      // console.log("localStoragePlugin - CLEAR_ALL_DATA")
      // console.log(localStorage.getItem("abft_intranet"))
      localStorage.removeItem(STORAGE_KEY)
    }
  })
}

// TODO: setup env
// export default process.env.NODE_ENV !== 'production' ? [localStoragePlugin] : [localStoragePlugin]
export default [localStoragePlugin]



// WEBPACK FOOTER //
// ./src/vuex/plugins.js